import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { UploadedFilesComponent } from './pages/uploaded-files/uploaded-files.component';
import { GenerateCodeComponent } from './pages/generate-code/generate-code.component';
import { ShowCodeComponent } from './pages/show-code/show-code.component';
import { RefactorComponent } from './refactor.component';

const routes: Routes = [
  {
    path: '',
    component: RefactorComponent,  // <--- Agregamos RefactorComponent como contenedor
    children: [
      { path: 'main', component: MainComponent },
      { path: 'uploaded-files', component: UploadedFilesComponent },
      { path: 'generate-code', component: GenerateCodeComponent },
      { path: 'show-code', component: ShowCodeComponent },

      { path: '', redirectTo: 'main', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RefactorRoutingModule { }
